import { isDatacreditoReportUrl, normalizeSecureFileUrl } from '@/utils/secureFileUrl'

export default {
  methods: {
    normalizeSecureFileUrl,

    async fetchSecureFileUrl (resourceType, id, attachment = null) {
      let path = `${this.url()}api/v1/secure_files/${resourceType}/${id}`
      if (attachment) {
        path += `?attachment=${encodeURIComponent(attachment)}`
      }
      const response = await this.requestGetWithoutContent(path, {})
      return response.data && response.data.url
    },

    async resolveSecureFileUrl (url, options = {}) {
      const { resourceType, id, attachment } = options
      const fallback = normalizeSecureFileUrl(url)

      // Reportes /datacredit/:id no pasan por Paperclip ni secure_files
      if (isDatacreditoReportUrl(fallback)) {
        return fallback
      }

      if (resourceType && id) {
        try {
          const freshUrl = await this.fetchSecureFileUrl(resourceType, id, attachment)
          if (freshUrl) return freshUrl
        } catch (_) {
          // 404 u otro error: usar URL del presenter si existe
        }
      }

      return fallback
    },

    async openSecureFileUrl (url, options = {}) {
      const fileUrl = await this.resolveSecureFileUrl(url, options)

      if (fileUrl) {
        window.open(fileUrl, '_blank')
      }
    }
  }
}
